/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi__pois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Sehenswürdigkeiten`
};

const en_zoi__pois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Points of interest`
};

const es_zoi__pois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Puntos de interés`
};

const fr_zoi__pois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Points d'intérêt`
};

const it_zoi__pois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Punti di interesse`
};

const nl_zoi__pois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Interessante punten`
};

const pt_zoi__pois_title = /** @type {(inputs: {}) => string} */ () => {
	return `Pontos de interesse`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi__pois_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi__pois_title", locale)
	if (locale === "de") return de_zoi__pois_title(inputs)
	if (locale === "en") return en_zoi__pois_title(inputs)
	if (locale === "es") return es_zoi__pois_title(inputs)
	if (locale === "fr") return fr_zoi__pois_title(inputs)
	if (locale === "it") return it_zoi__pois_title(inputs)
	if (locale === "nl") return nl_zoi__pois_title(inputs)
	return pt_zoi__pois_title(inputs)
};